module.exports = __webpack_public_path__ + "static/media/star-runner-screenshot-6.23a7e9b2.jpg";